import {DEFAULT_CLASS_TYPE} from "conts/options";

export * from "./dates.js";
export * from "./image.js";
export * from "./localStorage.ts";
export * from "./string.js";
export * from "./validation.ts";

export const getAvatarUrl = (url) => {
    if (!url) return ""
    const idx1 = url?.lastIndexOf("/");
    const profilePic = url.slice(idx1 + 1);
    return `https://d7eyk7icw439d.cloudfront.net/${profilePic}`;
};

export const getLowestValidPrice = (
    type_of_class,
    groupPrice,
    privatePrice,
) => {
    const validPrices = [groupPrice, privatePrice].filter(p => p > 0);

    switch (type_of_class) {
        case "Private and Group classes":
            return privatePrice > 0 ? privatePrice : 0;
        case "Private classes":
            return privatePrice > 0 ? privatePrice : 0;
        default:
            return groupPrice > 0 ? groupPrice : 0;
    }
};


export const isFirstClassFree = (classDetails) => {
    return !!classDetails?.discount_policy_for_private_class?.filter(
        (discount) =>
            discount?.policy === "First class" && discount?.percentage === 100,
    )?.length;
};

export const getHighestDiscount = (classDetails) => {
    const policies = classDetails?.discount_policy_for_private_class || [];

    if (!policies.length) return null;

    // Find highest % discount
    const highest = policies.reduce((acc, item) => {
        if (!item?.percentage) return acc;
        return item.percentage > acc.percentage ? item : acc;
    }, { percentage: 0 });

    return highest;
};


export const USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
});

export const getClassType = (instructorOnlineType, hasOnlineClass) => {
    if (
        (instructorOnlineType === "online" || instructorOnlineType === "both") &&
        hasOnlineClass
    ) {
        return DEFAULT_CLASS_TYPE;
    }
    return "offline";
};

export function normalizePercentage(value) {
    let strValue = String(value).trim();

    if (strValue === "") {
        strValue = "0";
    }

    const cleaned = strValue.replace(/^0+(\d)/, "$1");

    const numericValue = Number.parseFloat(
        cleaned === "" || !/^-?[\d.]/.test(cleaned) ? "0" : cleaned,
    );

    if (Number.isNaN(numericValue)) {
        return 0;
    }

    return Math.max(0, Math.min(100, numericValue));
}
